// Centralized business info for MANU VET — used across components.

export const BUSINESS = {
    name: 'MANU VET',
    logo: '/logos/manu-vet.png',
    tagline: 'Spécialiste des vêtements de travail',
    phone: '01 49 47 19 88',
    phoneTel: '+33149471988',
    email: 'nmanuvet@gmail.com',
    address: '37 Avenue Charles de Gaulle',
    city: 'Aulnay-sous-Bois',
    postalCode: '93600',
    department: '93 — Seine-Saint-Denis',
    region: 'Île-de-France',
    yearsInBusiness: 20,
    siteUrl: 'https://www.manu-vet.com',
    googleMapsUrl: 'https://www.google.com/maps/dir/?api=1&destination=37+Avenue+Charles+de+Gaulle+93600+Aulnay-sous-Bois',
    googleMapsEmbed: 'https://www.google.com/maps?q=37+Avenue+Charles+de+Gaulle+93600+Aulnay-sous-Bois&output=embed',
    googleReviewsUrl: 'https://www.google.com/search?q=manu+vet+aulnay-sous-bois#lrd=,1',
    googleReviewsSearchUrl: 'https://www.google.com/search?sca_esv=516c7d9f503f7416&q=manu+vet',
    instagramUrl: 'https://www.instagram.com/manu_vet_93/?hl=fr',
    tiktokUrl: 'https://www.tiktok.com/@manu.vet93',
    facebookUrl: 'https://www.facebook.com/profile.php?id=100004828549144',
    openingHours: [
        { day: 'Lundi — Vendredi', hours: '8h00 — 17h00' },
        { day: 'Samedi & Dimanche', hours: 'Fermé' },
    ],
};

export const CATEGORIES = [
    {
        slug: 'hommes',
        title: 'Hommes',
        kicker: '01',
        description: 'Pantalons cargo, vestes, blousons polaires, tee-shirts haute visibilité pour le BTP et l\'industrie.',
        image: 'https://customer-assets.emergentagent.com/job_manuvet-aulnay/artifacts/5ip9cbr2_7E4BBA55824A51BC5332.webp',
    },
    {
        slug: 'femmes',
        title: 'Femmes',
        kicker: '02',
        description: 'Coupes ajustées, confort durable, tailles 34 à 52 pour chantiers et ateliers.',
        image: 'https://customer-assets.emergentagent.com/job_manuvet-aulnay/artifacts/2vankwio_1A5989B364E8BC277C87.webp',
    },
    {
        slug: 'accessoires',
        title: 'Accessoires',
        kicker: '03',
        description: 'Chaussures S3, gants anti-coupure, lunettes balistiques, casques, harnais — tout l\'EPI normé CE.',
        image: 'https://customer-assets.emergentagent.com/job_manuvet-aulnay/artifacts/2mcm818s_eyJrZXkiOiJhSFIwY0hNNkx5OTNkM2N1YVc1emRHRm5jbUZ0TG1OdmJTOXlaV1ZzTDBSUlNGTlNWWGxwUjJvM0x3PT0vMF90aHVtYm5haWwiLCJlZGl0cyI6eyJ0b0Zvcm1hdCI6IndlYnAiLCJyZXNpemUiOnsid2lkdGgiOjMyMH19fQ%3D%3D.webp',
    },
];

/**
 * Brands. `domain` is used to fetch a favicon via Google s2/favicons as a fallback.
 * `logo` is a direct URL to a real logo image (preferred over the favicon when present).
 */
export const BRANDS = [
    { name: 'Blaklader', tag: 'Suède · Depuis 1959', domain: 'blaklader.com', logo: '/logos/blaklader.webp', highlight: true },
    { name: 'Utility Diadora', tag: 'Italie · Premium', domain: 'diadora.com', logo: 'https://customer-assets.emergentagent.com/job_manuvet-aulnay/artifacts/hdis17t4_Utility%20Diadora%20-%20MANUVET%20-%20boutique%20vente%20EPI%20-%20Vetement%20pro%20aulnay%20-%2093%20-%2093600.png' },
    { name: 'Safety Jogger', tag: 'Belgique · Sécurité', domain: 'safetyjogger.com' },
    { name: 'Lafont', tag: 'France · 1844', domain: 'lafont.fr', logo: 'https://customer-assets.emergentagent.com/job_manuvet-aulnay/artifacts/gc7o062x_logo-lafont-blanc%20%20-%20Vente%20boutique%20vetement%20pro%20et%20EPI%2093%20-%20Aulnay%20-%20Boutique%20MANUVET.webp', invert: true },
    { name: 'Delta Plus', tag: 'France · EPI complet', domain: 'deltaplus.com', logo: 'https://customer-assets.emergentagent.com/job_manuvet-aulnay/artifacts/x4cye7au_DELTA%20PLUS%20%20-%20Vente%20boutique%20vetement%20pro%20et%20EPI%2093%20-%20Aulnay%20-%20Boutique%20MANUVET.png' },
    { name: 'Cepovett', tag: 'France · Workwear', domain: 'cepovett.com', logo: 'https://customer-assets.emergentagent.com/job_manuvet-aulnay/artifacts/ubpo8rtg_CEPOVETT%20-%20Vente%20boutique%20vetement%20pro%20et%20EPI%2093%20-%20Aulnay%20-%20Boutique%20MANUVET.jpeg' },
    { name: 'Jallatte', tag: 'Chaussures de sécurité', domain: 'jallatte.fr' },
    { name: 'U-Power', tag: 'Italie · Chaussures', domain: 'u-power.it' },
    { name: 'Parade', tag: 'France · Chaussures', domain: 'parade.fr', logo: 'https://customer-assets.emergentagent.com/job_manuvet-aulnay/artifacts/dai8w9hx_parade%20%20-%20Vente%20boutique%20vetement%20pro%20et%20EPI%2093%20-%20Aulnay%20-%20Boutique%20MANUVET.png' },
    { name: 'LMA', tag: 'France · Workwear 1880', domain: 'lma-vetements.fr', logo: 'https://customer-assets.emergentagent.com/job_manuvet-aulnay/artifacts/guo9okj1_lma-logo%20%20-%20Vente%20boutique%20vetement%20pro%20et%20EPI%2093%20-%20Aulnay%20-%20Boutique%20MANUVET.webp' },
    { name: 'Singer Safety', tag: 'France · EPI', domain: 'singer-safety.com', logo: 'https://customer-assets.emergentagent.com/job_manuvet-aulnay/artifacts/zthymaty_SINGER%20safety%20%20-%20Vente%20boutique%20vetement%20pro%20et%20EPI%2093%20-%20Aulnay%20-%20Boutique%20MANUVET.png' },
    { name: 'Northways', tag: 'France · Uniformes', domain: 'northways.fr', logo: 'https://customer-assets.emergentagent.com/job_manuvet-aulnay/artifacts/elkrvpgw_Northways%20%20-%20Vente%20boutique%20vetement%20pro%20et%20EPI%2093%20-%20Aulnay%20-%20Boutique%20MANUVET.png' },
    { name: 'Payper', tag: 'Italie · Confort technique', domain: 'payper.com', logo: 'https://customer-assets.emergentagent.com/job_manuvet-aulnay/artifacts/c9wn5ks9_Payper%20-%20Vente%20boutique%20vetement%20pro%20et%20EPI%2093%20-%20Aulnay%20-%20Boutique%20MANUVET.jpg' },
];

export const SERVICES = [
    {
        code: 'S/01',
        title: 'Flocage & Broderie',
        description:
            'Personnalisation sur-mesure de vos vêtements : logo brodé, transfert, sérigraphie. Notre atelier traite aussi bien la pièce unique que les commandes en série pour habiller toutes vos équipes.',
        bullets: ['Devis rapide', 'Atelier intégré', 'Toutes quantités'],
    },
    {
        code: 'S/02',
        title: 'Livraison Île-de-France',
        description:
            "Livraison rapide à Aulnay-sous-Bois, en Seine-Saint-Denis et dans toute l'Île-de-France. Pour les chantiers et les sociétés, nous nous adaptons à vos délais et à vos exigences logistiques.",
        bullets: ['IDF 24/72h', 'Suivi de commande', 'Conseil dédié'],
    },
];

export const CLIENTS = [
    'CNGT',
    'AIR CRAFT — CABINET D\'AIRE',
    'FONBONNE',
    'H MARKET',
    'PAPREC',
    'GREEN RECUP',
    'SNCF',
    'BUT',
    'GCC',
    'OKARRE',
    'GODET GROUPE',
    'KINTESSIA',
    'ESPACE MA BOUCHERIE',
    'DISTRI PNEU',
    'EURO REPAR',
    'MIDAS',
    'MEDERREG',
    'FLY CAR',
    'FOURGO',
    'GEODIS',
    'MONTAGRU',
    'PRÉFECTURE DE PARIS',
    'PRÉFECTURE ROISSY — ADP',
];

export const CLIENTS_FEATURED = ['GODET GROUPE', 'SNCF', 'GEODIS', 'PAPREC', 'PRÉFECTURE DE PARIS'];

export const SECTORS = [
    'BTP',
    'Aéroportuaire',
    'Médical',
    'Cuisine',
    'Automobile',
    'Défense',
    'Propreté',
    'Sécurité',
    'Incendie',
    'Levage',
    'Transport',
    'Logistique',
];

export const SECTORS_OTHER = { label: 'Autres', symbol: '∞' };

// Legal / RGPD information (obligatoire loi française + RGPD)
export const LEGAL = {
    companyName: 'MANU VET',
    legalForm: 'EURL — Entreprise Unipersonnelle à Responsabilité Limitée',
    capital: '7 500,00 €',
    siren: '788 844 355',
    siret: '788 844 355 00024',
    rcs: '788 844 355 R.C.S. Bobigny',
    rcsDate: '22/10/2012',
    vat: 'FR21788844355',
    publicationDirector: 'Nordine Laakel',
    hostName: 'Hostinger International Ltd.',
    hostAddress: '61 Lordou Vironos Street, 6023 Larnaca, Chypre',
    hostSite: 'https://www.hostinger.fr',
    dataOfficerEmail: 'nmanuvet@gmail.com',
    lastUpdated: '20 février 2026',
};
